import { render, staticRenderFns } from "./QuestionAnswerInfo.vue?vue&type=template&id=ef3998b4&scoped=true"
import script from "./QuestionAnswerInfo.vue?vue&type=script&lang=js"
export * from "./QuestionAnswerInfo.vue?vue&type=script&lang=js"
import style0 from "./QuestionAnswerInfo.vue?vue&type=style&index=0&id=ef3998b4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3998b4",
  null
  
)

export default component.exports